import React from 'react';
import { useBranding } from '@/hooks/useBranding';
import BrandingUploader from './BrandingUploader';

const FaviconUploader: React.FC = () => {
  const { favicon, uploadBrandingFile, resetToDefault } = useBranding();

  return (
    <BrandingUploader
      label="Favicon"
      currentUrl={favicon?.file_url}
      acceptedTypes="image/png, image/x-icon, image/vnd.microsoft.icon"
      acceptedTypesLabel="PNG, ICO"
      maxSizeKb={512}
      recommendedSize="32x32px or 512x512px"
      onUpload={async (file) => {
        const result = await uploadBrandingFile('favicon', file);
        return result.fileUrl;
      }}
      onReset={async () => resetToDefault('favicon')}
      previewHeight="h-32"
    />
  );
};

export default FaviconUploader;
